import { configureStore } from "@reduxjs/toolkit";

import authSlice from "./slices/authSlice";
import {chatReducer} from "../components/ChatWidget/ChatWidget";

import { apiSlice } from "./slices/apiSlice";

const store = configureStore({
  reducer: {
    auth: authSlice,

    // USER CHAT
    chat: chatReducer,

    // RTK QUERY
    [apiSlice.reducerPath]: apiSlice.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export default store;
